export const PASSWORD_UPDATED = "Your Password Updated Successfully!";

export const INTERNAL_SERVER_ERROR = "Internal Server Error";
export const VALIDATION_ERROR = "Validation Error";
export const CATEGORIES_CREATED = "Category Created Successfully!";
export const CATEGORIES_UPDATED = "Category Updated Successfully!";

export const USER_CREATED = "User Created Successfully!";
export const USER_UPDATED = "User Updated Successfully!";
export const USER_DELETED = "User Deleted Successfully!";
export const USER_CHAPTER_CHANGED = "User Chapted Changed Successfully!";

export const REGION_CREATED = "Region Created Successfully!";
export const REGION_UPDATED = "Region Updated Successfully!";
export const REGION_DELETED = "Region Deleted Successfully!";

export const COUNTRY_CREATED = "Country Created Successfully!";
export const COUNTRY_UPDATED = "Country Updated Successfully!";
export const COUNTRY_DELETED = "Country Deleted Successfully!";

export const STATE_CREATED = "State Created Successfully!";
export const STATE_UPDATED = "State Updated Successfully!";
export const STATE_DELETED = "State Deleted Successfully!";

export const CHAPTER_CREATED = "Chapter Created Successfully!";
export const CHAPTER_UPDATED = "Chapter Updated Successfully!";
export const CHAPTER_DELETED = "Chapter Deleted Successfully!";

export const USER_ROLE_CREATED = "User Role Created Successfully!";
export const USER_ROLE_UPDATED = "User Role Updated Successfully!";
export const USER_ROLE_DELETED = "User Role Deleted Successfully!";

export const CATEGORY_CREATED = "Category Created Successfully!";
export const CATEGORY_UPDATED = "Category Updated Successfully!";
export const CATEGORY_DELETED = "Category Deleted Successfully!";

export const BLOOD_GROUP_CREATED = "Blood Group Created Successfully!";
export const BLOOD_GROUP_UPDATED = "Blood Group Updated Successfully!";
export const BLOOD_GROUP_DELETED = "Blood Group Deleted Successfully!";

export const CROWN_CREATED = "Crown Created Successfully!";
export const CROWN_UPDATED = "Crown Updated Successfully!";
export const CROWN_DELETED = "Crown Deleted Successfully!";

export const TIMER_CREATED = "Timer Created Successfully!";
export const TIMER_UPDATED = "Timer Updated Successfully!";
export const TIMER_DELETED = "Timer Deleted Successfully!";
export const TIMER_ACCESS_UPDATED = "Timer Access Updated Successfully!";
export const CHAPTER_FINANCE_ACCESS_UPDATED = "Chapter Finance Access Updated Successfully!";

export const ROLE_CREATED = "Role Created Successfully!";
export const ROLE_UPDATED = "Role Updated Successfully!";
export const ROLE_DELETED = "Role Deleted Successfully!";

export const COUNTRY_ADMIN_USER_CREATED = "Country Admin User Created Successfully!";
export const COUNTRY_ADMIN_USER_UPDATED = "Country Admin User Updated Successfully!";
export const COUNTRY_ADMIN_USER_DELETED = "Country Admin User Deleted Successfully!";

export const STATE_ADMIN_USER_CREATED = "State Admin User Created Successfully!";
export const STATE_ADMIN_USER_UPDATED = "State Admin User Updated Successfully!";
export const STATE_ADMIN_USER_DELETED = "State Admin User Deleted Successfully!";

export const CHAPTER_ADMIN_USER_CREATED = "Chapter Admin User Created Successfully!";
export const CHAPTER_ADMIN_USER_UPDATED = "Chapter Admin User Updated Successfully!";
export const CHAPTER_ADMIN_USER_DELETED = "Chapter Admin User Deleted Successfully!";

export const REGION_ADMIN_USER_CREATED = "Region Admin User Created Successfully!";
export const REGION_ADMIN_USER_UPDATED = "Region Admin User Updated Successfully!";
export const REGION_ADMIN_USER_DELETED = "Region Admin User Deleted Successfully!";

export const EVENT_CREATED = "Event Created Successfully!";
export const EVENT_UPDATED = "Event Updated Successfully!";
export const EVENT_DELETED = "Event Deleted Successfully!";

export const NEWS_CREATED = "News Created Successfully!";
export const NEWS_UPDATED = "News Updated Successfully!";
export const NEWS_DELETED = "News Deleted Successfully!";

export const FORUM_SETTINGS_UPDATED = "Forum Settings Updated Successfully!";

export const MEETING_UPDATED = "Meeting Updated Successfully!";
export const MEETING_DELETED = "Meeting Deleted Successfully!";
export const MEETING_CANCELLED = "Meeting Cancelled Successfully!";

export const POINTS_SYSTEM_UPDATED = "Points System Updated Successfully!";

// ## Constant Variable
export const PAGINATE = "paginate";
export const NOPAGINATE = "nopaginate";
export const DROPDOWN = "dropdown";
export const ACTIVE = "Active";
export const INACTIVE = "Inactive";